import ExtraMaterial from 'services/course/models/extra-material-interface';

import IconDownload from 'assets/icon/icone-download.svg';
import IconPlay from 'assets/icon/icone-play.svg';

interface IExtraMaterialCard {
  materialCourse: ExtraMaterial;
}

const ExtraMaterialCard: React.FC<IExtraMaterialCard> = ({
  materialCourse,
}) => {
  return (
    <div className="extra-material-card">
      <a
        href={materialCourse.reference}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="info-support-card">
          <span className="material-type">{materialCourse.name}</span>

          <p>{materialCourse.info.description}</p>
        </div>
        {materialCourse.name === 'EBOOK' ? (
          <img src={IconDownload} alt="Download" />
        ) : (
          <img src={IconPlay} alt="Play" />
        )}
      </a>
    </div>
  );
};

export default ExtraMaterialCard;
